import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Tabs(theme: Theme) {
  return {
    MuiTabs: {
      defaultProps: {},
      styleOverrides: {
        root: {
          '& .MuiTab-root': {
            height: '68px',
            minHeight: '68px',
            fontSize: '16px',
            fontWeight: '600',
          },
          '& .MuiTabs-indicator': {
            height: '3.5px',
          },
        },
      },
    },
    MuiTab: {
      defaultProps: {},
      styleOverrides: {
        root: {
          color: theme.palette.primary.main,
          padding: '16.5px 16px 32.5px 16px',
          textTransform: 'none',
        },
      },
    },
  }
}
